import type { ReorderInspectionTemplateParams } from 'react-hooks';

import type { ReorderChange } from '../model/changes';

export type ReorderInput = {
  channelId: string;
  templateId: string;
  change: ReorderChange;
};

// The change already carries the full list, hidden entries included, in the order the user
// sees. The server takes one list per request and ignores the other
export function buildReorderParams({
  channelId,
  templateId,
  change,
}: ReorderInput): ReorderInspectionTemplateParams {
  switch (change.kind) {
    case 'reorderSections':
      return {
        channelId,
        templateId,
        sectionIds: change.sectionIds,
        sections: [],
      };
    case 'reorderQuestions':
      return {
        channelId,
        templateId,
        sectionIds: [],
        sections: [{ sectionId: change.sectionId, itemIds: change.itemIds }],
      };
  }
}
